import { html } from "lit";

// Limited to icons that actually exist in the sprite
// (src/shared/components/templates/icons.js) — there is no "check-circle".
const ICONS_BY_LEVEL = {
    'alert-success': { icon_class: 'fa fa-check', color: 'var(--success-color)' },
    'alert-danger': { icon_class: 'fa fa-times-circle', color: 'var(--danger-color)' },
    'alert-info': { icon_class: 'fa fa-info-circle', color: 'var(--info-color)' },
};

export default (o) => {
    const icon = ICONS_BY_LEVEL[o.level];
    return html`<div class="modal-body modal-body--alert"><span class="modal-alert"></span> ${icon
            ? html`<converse-icon size="2.5em" class="${icon.icon_class} modal-body--alert__icon" color="${icon.color}"></converse-icon>`
            : ''} ${ o.messages.map(message => html`<p>${message}</p>`) }</div>`;
};
